import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'guide',
            component: () => import(/* webpackChunkName: "guide" */ './views/guide.vue'),
        },
        {
            path: '/info',
            name: 'info',
            component: () => import(/* webpackChunkName: "info" */ './views/info.vue'),
        },
        {
            path: '/real-authentication',
            name: 'real-authentication',
            component: () => import(/* webpackChunkName: "realAuthentication" */ './views/real-authentication.vue'),
        },
        {
            path: '/about',
            name: 'about',
            component: () => import(/* webpackChunkName: "about" */ './views/about.vue'),
        },
        {
            path: '/auth-success',
            name: 'auth-success',
            component: () => import(/* webpackChunkName: "auth-success" */ './views/auth-success.vue'),
        },
        {
            path: '/service-auth',
            name: 'service-auth',
            component: () => import('./views/service-auth.vue'),
        },
    ],
});
